import React from 'react';
import AllCameraListContainer from '../components/AllCameraList/AllCameraList';

const AllCameraList = () => {
  return <AllCameraListContainer />;
};

export default AllCameraList;
